import { Box, Loader } from 'braid-design-system';
import React from 'react';

export const LoadableFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    padding="xxlarge"
    background="surface"
  >
    <Loader />
  </Box>
);
